const FRAME_COUNT = 20;
const frameUrl = (frame: number) =>
  `/art/workday-v2/palm-frames/frame-${String(frame).padStart(2, '0')}.webp`;

/** Only model-generated raster frames are rendered; no procedural icon drawing. */
export function IslandBadge({
  progress,
  resting = false,
}: {
  progress: number;
  resting?: boolean;
}) {
  if (resting)
    return (
      <span className="workday-island-art" aria-hidden="true">
        <img src="/art/workday-v2/holiday.png" alt="" draggable={false} />
      </span>
    );
  const position =
    Math.max(0, Math.min(1, Number.isFinite(progress) ? progress : 0)) * (FRAME_COUNT - 1);
  const frame = Math.floor(position);
  return (
    <span className="workday-island-art" aria-hidden="true">
      <img src={frameUrl(frame)} alt="" draggable={false} />
      {frame < FRAME_COUNT - 1 && (
        <img
          src={frameUrl(frame + 1)}
          alt=""
          draggable={false}
          style={{ opacity: position - frame }}
        />
      )}
    </span>
  );
}
